module.exports = __webpack_public_path__ + "static/media/About-Us_525x368.cb2770a4.jpg";